import React, { Component } from "react";
import { Text, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { withTranslation } from "react-i18next";

import config from "../../temp/config";

class PageContactConnect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			serverError: false,
			formSubmitted: false,
			UrlContact: `${config.sitecoreApiHost}/apiaox/Call/Contact`,
			apiDatas: [],
			initDataOK: false,
		};
		this.bPushTrackPageResult_Done = false;
	}
	componentDidMount() {
		window.scrollTo(0, 0);
	}
	render() {
		const oCurrentItemFields = this.props.sitecoreContext.route?.fields;

		return (
			<section className="section_form">
				<div className="str_container">
					<div className="ctn_top">{oCurrentItemFields && <Text tag="h1" field={oCurrentItemFields["Page Title"]}></Text>}</div>
					<div className="ctn_form">
						<div className="ctn_col col_left">
							<div className="ctn_contact">
								<h3>{this.props.t("Register_contactQuestion")}</h3>
								<p className="t_tel" dangerouslySetInnerHTML={{ __html: this.props.t("Register_contactPhone") }}></p>
								<p className="t_mention">{this.props.t("Register_contactByPhonePrice")}</p>
							</div>
						</div>
						<div className="ctn_col col_right">
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export default withTranslation()(withSitecoreContext()(PageContactConnect));
